export const HEADER_HEIGHT = 48;
